export default {
  Titleemail: 'Correo electrónico',
  password: 'Contraseña',
  EmailConfirmation: ' Confirmar Correo electrónico ',
  Confirm_Password: 'Confirmar contraseña',
  Document_type: 'Tipo de documento',
  Identification_document: 'Documento de Identidad',
  name: 'Nombre',
  First_last_name: 'Primer apellido',
  Second_last_name: 'Segundo apellido',
  occupation: 'Ocupación',
  state: 'Provincia',
  Municipality: 'Municipio',
  Sector: 'Sector',
  Telephone_contact: 'Teléfono de contacto',
  Secondary_contact_phone: 'Teléfono de contacto secundario',
  Address: 'Dirección',
  conditions: 'Acepto los terminos y condiciones de uso y privacidad',
  Back: 'Retroceder',
  Continue: 'Continuar',
  Register: 'Registrar',
  Registro_ciudadano: '  Registro Ciudadano',
  myText: [
    {

      text: "mmi libro"
    },
    {

      text: "mi texto"
    }
  ],


  //test

  RegisterSteps: [
    {
      title: 'Información de Autenticación',
      //title: i18next.t('register'),
      elements: [
        'email',
        'emailConfirmation',
        'password',
        'password_confirmation'
      ]
    },
    {
      title: 'Datos Personales',
      elements: [
        'document_type',
        'citizen_id',
        'name',
        'first_last_name',
        'second_last_name',
        'occupation',
        'province_id',
        'municipality_id',
        'sector_id',
        'phone',
        'phone2',
        'email2',
        'address'
      ]
    },
    {
      title: 'Términos y condiciones',
      elements: [
        'termsAndCondition'
      ]
    },
    {
      title: 'Activación de cuenta'
    },
  ],





}





